import { Component, OnInit } from '@angular/core';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { BaseProductComponent } from '@product/shared/base-product.component';
import {  CatalogProduct } from '@product/shared/models/catalog';
import { catchError, forkJoin, map, Observable, of, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-catalog-cards',
  templateUrl: './catalog-cards.component.html',
  styleUrls: ['./catalog-cards.component.less']
})
export class CatalogCardsComponent extends BaseProductComponent implements OnInit {
  url = AppConfigService.settings.baseUrl;
  catalogName: string = '';
  description: string = '';
  isLoading: boolean = false;
  productsCatalog: CatalogProduct;
  catalogId: number;
  catalogCode:string='';
  catalogImageUrl: string;
  catalogBannerUrl: string;
  configTableParams = {
    currentPage: 1,
    pageSize: 10,
  };
 
  searchValue: string = '';
  filteredCatalog: any;
  isAuthorized:boolean=false;
  ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params['id'] ||params['catalogCode']) {
        this.catalogId = +params['id'];
        this.catalogCode=params['catalogCode'];
        this.getCatalogProducts()
      }
     
    });

    this.isAuthorized = !!localStorage.getItem('token'); 
  }

getImageUrl(mediaObjectId: number, catalogCode: string): Observable<string | null> {
  if (!mediaObjectId) {
    return of(null);
  }
  
  return this.productCatalog.getImage({ id: mediaObjectId, catalogCode }).pipe(
    catchError(() => of(null)),
    switchMap(blob => {
      if (!blob) {
        return of(null);
      }
      const url = this.productCatalog.createImageUrl(blob);
      return of(url);
    })
  );
}

getImageUrlByCode(imageCode: string): Observable<string | null> {
  if (!imageCode) {
    return of(null);
  }
  
  return this.mediaService.getMediaByCode(imageCode).pipe(
    catchError(() => of(null)),
    switchMap(blob => {
      if (!blob) {
        return of(null);
      }

      const url = this.productCatalog.createImageUrl(blob);
      return of(url);
    })
  );
}

getCatalogProducts() {
  this.isLoading = true;

  this.productCatalog.getCatalogProducts(this.catalogId, this.catalogCode).pipe(
    switchMap(catalogData => {
      this.productsCatalog = catalogData;
      this.catalogName = catalogData.name;
      this.description = catalogData.description;

      const bannerRequest = this.getImageUrl(catalogData.bannerMediaObjectId, this.catalogCode);
      const thumbnailRequest = this.getImageUrl(catalogData.thumbnailMediaObjectId, this.catalogCode);

      return forkJoin({
        catalogData: of(catalogData),
        bannerUrl: bannerRequest,
        thumbnailUrl: thumbnailRequest
      });
    }),
    switchMap(({ catalogData, bannerUrl, thumbnailUrl }) => {
      this.catalogImageUrl = bannerUrl ? bannerUrl : '';
      this.catalogBannerUrl = thumbnailUrl ? thumbnailUrl : '';

     const productsWithImages$ = catalogData.products.map((product: any) => {

  const { mainImage, ...productWithoutImage } = product;
      
  return this.getImageUrlByCode(product.imageCode).pipe(
    map(imageBase64 => ({
      ...productWithoutImage, 
      mainImage: imageBase64 
    }))
  );
});


      return forkJoin(productsWithImages$);
    })
  ).subscribe({
    next: (productsWithImages) => {
      this.filteredCatalog = productsWithImages;
       this.productsCatalog.products = productsWithImages;
      
      this.isLoading = false;
      this.updatePagination();
      
    },
    error: (error) => {
     
     this.isLoading = false;
    }
  });
}

  search() {
    const searchValue = this.searchValue?.toLowerCase().trim().replace(/\s+/g, "") || "";
  
    this.filteredCatalog = searchValue
      ? this.productsCatalog.products.filter((catalog: any) =>
          (catalog?.name?.toLowerCase().replace(/\s+/g, "") || "").includes(searchValue) ||
          (catalog?.sku?.toLowerCase().replace(/\s+/g, "") || "").includes(searchValue)
        )
      : [...this.productsCatalog.products];
  
      this.updatePagination();
  }
  
  
   updatePagination() {
    
    const startIndex = (this.configTableParams.currentPage - 1) * this.configTableParams.pageSize;
    const endIndex = startIndex + this.configTableParams.pageSize;
    this.filteredCatalog = this.productsCatalog.products.slice(startIndex, endIndex);
  }

  onPageChange(page: number) {
    
    this.configTableParams.currentPage = page;
    this.updatePagination();
  }

   override ngOnDestroy(): void {
   this.productCatalog.revokeAll();
    super.ngOnDestroy();
  }

}
